import $ from "jquery";
import React, { Component } from "react";
import { Field, formValueSelector, change } from 'redux-form';
import { connect } from "react-redux";
import { Row } from "react-foundation";

import Loading from "components/Loading";
import Tick from "components/Tick";

import utils from "utils";

// TODO: Change
import SlickSlider from "components/SlickSlider";
import Image from "components/Image";
import InputError from "../../components/InputError";
import ThemeButton from "../../components/ThemeButton";
import SeparatingLine from "../../components/SeparatingLine";
import { getDoorTypes, updatePreviousSelection } from '../../actions';
import FormHeader from "../../components/FormHeader";
import FormWrapper from "../FormWrapper";

class SelectType extends Component {
    renderType(value, id) {
        return (
            <div key={id}>
                <div className="slick-slide-image-container">
                    <Tick />
                    <Image
                        src={value.externalImageUrl}
                        alt=""
                        placeholderText={value.name}
                        className="slick-slide-image"
                    />
                </div>
                <p className={"slick-slide-title"}>{value.name}</p>
                <p className={"slick-slide-subtitle"}>{value.notes}</p>
            </div>
        );
    }
    render() {
        let { types, input } = this.props;

        if ($.isEmptyObject(types)) {
            return <Loading />;
        }

        return (
            <div>
                <Row>
                    <SlickSlider
                        values={types}
                        selectedId={input.value}
                        onDisplay={this.renderType.bind(this)}
                        onChange={input.onChange}
                    />
                </Row>
                <InputError metas={this.props.meta} />
            </div>
        );
    }
}

class TypeForm extends Component {
    componentDidMount() {
        // let itemTypeId = 2; // door

        this.props.getDoorTypes(this.props.doorRoomId);
    }

    componentDidUpdate() {
        let { selectedType, types, dispatch, previousSelection } = this.props;

        if (!selectedType.id) {
            if (types.length > 0) {
                // do something
                if (previousSelection.DoorTypeId)
                    dispatch(change("DoorWizard", "DoorTypeId", previousSelection.DoorTypeId));
            }
        }
    }
    onSubmit(values) {
        let doorTypeId = values.DoorTypeId;

        let type = utils.getValueById(this.props.types, doorTypeId);

        this.props.setDoorType(type.name);


        this.props.updatePreviousSelection({
            DoorTypeId: values.DoorTypeId
        });

        this.props.onSubmit();
    }

    render() {
        return (
            <form className="TypeForm" onSubmit={this.props.handleSubmit(this.onSubmit.bind(this))}>
                <FormHeader
                    title={"Pick your type"}
                    subtitle={
                        "From stunning composite doors to contemporary and secure garden doors."
                    }
                />

                <SeparatingLine />

                <FormWrapper>
                    <Field name="DoorTypeId" component={SelectType} types={this.props.types} />
                </FormWrapper>

                <div className="button-panel">
                    <SeparatingLine />
                    <button className="button back" type="button" onClick={this.props.previousPage}>
                        Back
                    </button>
                    <ThemeButton className="next">Next</ThemeButton>
                </div>
            </form>
        );
    }
}

const mapStateToProps = state => {
    let valueSelector = formValueSelector("DoorWizard");
    let doorRoomId = valueSelector(state, "DoorRoomId");

    let doorTypeId = valueSelector(state, "DoorTypeId");
    let selectedType = state.Door.Types.filter(c => c.id === doorTypeId)[0] || {};

    return {
        types: state.Door.Types,
        doorRoomId,
        selectedType,
        previousSelection: state.PreviousSelection
    };
};

export default connect(mapStateToProps, { getDoorTypes, updatePreviousSelection })(TypeForm);



// WEBPACK FOOTER //
// ./src/containers/DoorForm/TypeForm.js